import { GeneralInfoNav } from "./generalInfoComponents/generalInfoNav";
import { useSearchParams } from "react-router-dom";
import { GeneralInfoCompany } from "./generalInfoComponents/billingEntities/generalInfoCompany";
import { GeneralInfoUsers } from "./generalInfoComponents/users/generalInfoUsers";
import { GeneralInfoPickup } from "./generalInfoComponents/pickupLocations/generalInfoPickup";
import { GeneralInfoPayment } from "./generalInfoComponents/paymentMethods/generalInfoPayment";
import { useGetCompany } from "../../api/company.api";

export const GeneralInfo = () => {
  const [searchParams] = useSearchParams();

  const { data: company } = useGetCompany();

  const displayTab = () => {
    switch (Number(searchParams.get("subTab")) || 0) {
      case 0:
        return <GeneralInfoCompany company={company} />;
      case 1:
        return <GeneralInfoUsers />;
      case 2:
        return <GeneralInfoPickup company={company} />;
      case 3:
        return <GeneralInfoPayment company={company} />;
      default:
        return null;
    }
  };

  return (
    <div className="flex h-full w-full flex-1 flex-col items-center gap-4 md:gap-8">
      <GeneralInfoNav />
      {displayTab()}
    </div>
  );
};
